
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30989',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30989",
  "emoji-mart": "static-3.6",
  "feedback-schema": "static-1.55569",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8494",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11947",
  "I18n": "static-7.1705",
  "quartz": "static-1.7636",
  "quartz-config": "static-1.1414",
  "quartz-core": "static-1.6855",
  "react-dlb": "static-1.93",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.84",
  "reselect": "static-3.16",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1081",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55556",
  "feedback-utils": "static-1.55560",
  "forms-embed-utils-lib": "static-1.4919",
  "forms-utils-lib": "static-1.13308",
  "foundations-assets": "static-1.5343",
  "foundations-components": "static-1.8718",
  "foundations-theming": "static-1.4944",
  "hub-http": "static-1.6665",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12254",
  "icons": "static-2.700",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4223",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17193",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5648",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.517",
  "tinymce-plugins": "static-1.58477",
  "transmute": "static-2.97",
  "ui-images": "static-2.1274",
  "UIComponents": "static-3.8893",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3913",
  "quartz-webpack": "static-1.3860",
  "foundations-theming-specialty": "static-1.2660",
  "property-description-translator": "static-1.4276",
  "HeadJS": "static-2.818",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3605",
  "msw": "static-1.102",
  "msw-config": "static-1.26",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4765",
  "jasmine-runner": "static-1.6909",
  "opentelemetry-fe-types": "static-1-unrevert-default-instrumentation.4",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.904",
  "hubspotter-http": "static-1.4968",
  "mobile-manifest-mixins": "static-1.602",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1-unrevert-default-instrumentation.4",
  "quartz-auth": "static-1.1311",
  "quartz-head": "static-1.1301",
  "quartz-i18n": "static-1.1311",
  "quartz-routing": "static-1.1066",
  "quartz-test": "static-1.1311",
  "quartz-tracking": "static-1.1015",
  "trellis-components": "static-1.3062",
  "ui-fonts": "static-1.1209",
  "usage-tracker-container": "static-1.7769",
  "usage-tracker-core": "static-1.7629",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.346",
  "conversations-skeleton-state": "static-1.7605",
  "reference-resolvers": "static-1.8637",
  "sanitize-text": "static-1.8615",
  "PatternValidationJS": "static-1.3343",
  "ReduxMessenger": "static-2.10827",
  "outpost": "static-1.4589",
  "rpc-client-utils": "static-1.5128",
  "sanitize": "static-1.4931",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4987",
  "floating-ui": "static-1.67",
  "hs-story-utils": "static-1.9880",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.100",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.3043",
  "bend-plugin-foundations-theming": "static-1.3427",
  "foundations-theming-base": "static-1.3929",
  "stylex": "static-1.46",
  "hs-locale-management": "static-1.392",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.157",
  "web-vitals": "static-1.19",
  "ai-components-ui-library": "static-1.9987",
  "atom": "static-1.5532",
  "codemirror": "static-5.106",
  "content-assistance-lib": "static-1.8397",
  "ContentUtils": "static-1.69435",
  "data-token-picker": "static-1.17105",
  "file-manager-components": "static-1.24806",
  "FileManagerCore": "static-1.40305",
  "FileManagerLib": "static-1.40446",
  "frontend-preferences-client": "static-1.8377",
  "hub-http-contrib": "static-1.3488",
  "interframe": "static-3.5198",
  "layout-dnd-components": "static-1.13196",
  "layout-dnd-utils": "static-1.12171",
  "property-translator": "static-1.5836",
  "react-codemirror": "static-1.11098",
  "react-colorpicker": "static-2.10667",
  "reference-resolvers-lite": "static-1.8564",
  "rich-text-lib": "static-1.20523",
  "tinymce-data": "static-1.41448",
  "tinymce-themes": "static-1.57333",
  "ui-addon-emoji-picker": "static-1.10322",
  "ui-addon-sales-email": "static-1.5660",
  "ui-brand-identity-lib": "static-1.16909",
  "bender-build-tools": "static-1.3556",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10871",
  "hubspotter-http-shared-msw-handlers": "static-1.10869",
  "usage-tracker-session-replay": "static-1.5465",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1453",
  "tanstack-virtual": "static-1.42",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.538",
  "chirp-fetch": "static-1.2361",
  "stylex-utils": "static-1.171",
  "chatspot-core": "static-1.23753",
  "copilot-toolkit": "static-1.12112",
  "customer-data-objects-ui-components": "static-1.13487",
  "data-fetching-client": "static-1.10096",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5214",
  "ui-addon-video-player": "static-1.9082",
  "ui-coaching-tips": "static-1.29564",
  "usage-tracker": "static-1.7779",
  "cms-field-types": "static-1.5268",
  "content-icons-ui": "static-1.2440",
  "integrations-lib": "static-1.17390",
  "customer-data-objects": "static-1.8154",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2100",
  "apollo-link-hub-http": "static-2.5043",
  "apollo-stack-hubspot": "static-3.98",
  "graphql": "static-1.93",
  "immer": "static-1.105",
  "immerable": "static-1.4600",
  "poll-commands": "static-1.3934",
  "ui-addon-iframeable": "static-1.9532",
  "video-components-external": "static-1.12400",
  "video-data-lib": "static-1.36058",
  "audio-components": "static-1.6543",
  "breeze-artifacts-sdk": "static-1.867",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30029",
  "FileManagerImages": "static-1.37957",
  "foundations-components-legacy": "static-1.1743",
  "html-to-image": "static-1.65",
  "redux-toolkit": "static-1.82",
  "salesImages": "static-1.714",
  "ui-universal-auth": "static-1.9691",
  "urlinator": "static-1.4972",
  "video-components": "static-1.14402",
  "video-embed": "static-1.36892",
  "ts-schema": "static-1.4387",
  "ContentData": "static-1.69510",
  "layout-data-lib": "static-1.10496",
  "react-dnd-compat": "static-1.5068",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2003",
  "external-options-client-types": "static-1.4433",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6048",
  "hs-resources": "static-1.651",
  "inbound-db-properties-service-client": "static-1.4144",
  "NamespacedHubStyle": "static-2.9360",
  "growth-onboarding-confetti": "static-1.3518",
  "SharedI18nStrings": "static-1.187",
  "ui-addon-i18n": "static-1.11604",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5895",
  "magpie-types": "static-1.5355",
  "simple-logging-lib": "static-1.3508",
  "avatar-components": "static-1.2944",
  "customer-data-ui-utilities": "static-1.10291",
  "growth-onboarding-feedback-components": "static-1.7039",
  "flux-actions": "static-1.380",
  "hubspot-apollo-client": "static-1.5336",
  "integrations-error-boundary-lib": "static-1.14805",
  "integrations-tracking-lib": "static-1.6074",
  "laboratory-lib": "static-3.7606",
  "native-integrations-shared-strings": "static-1.8220",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10733",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1078",
  "breeze-engine-core": "static-1.1378",
  "highlight.js": "static-1.90",
  "pulse": "static-1.1102",
  "navigation-messaging": "static-1.8454",
  "content-media-composition-data-lib": "static-1.13560",
  "content-media-compositions": "static-2.17567",
  "idb-keyval": "static-1.55",
  "media-bridge-lib": "static-1.19614",
  "nudge-client-utils": "static-1.3386",
  "unified-auth-core-lib": "static-1.1487",
  "social-insights-client-types": "static-1.22898",
  "advanced-menus-core": "static-1.15785",
  "advanced-menus-lib": "static-1.12546",
  "ExportDialog": "static-6.10828",
  "ui-memberships-settings-lib": "static-1.35145",
  "conditional-properties-service-client": "static-1.4105",
  "crm-pipelines-api-client-types": "static-1.4436",
  "event-emitter": "static-1.1419",
  "fdsr-migration-layer": "static-1.469",
  "framework-builder-read-service-client": "static-1.4327",
  "inbound-db-meta-service-client": "static-1.3768",
  "multi-currency-client-types": "static-1.4000",
  "foundations-components-test-utils": "static-1.6201",
  "reactive-lib": "static-1.1179",
  "trellis-migration-context": "static-1.35",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.795",
  "universal-page-editor-lib": "static-1.3465",
  "bend-plugin-pulse": "static-1.605",
  "fast-json-patch": "static-1.74",
  "nav-meta": "static-1.30764",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3143",
  "nudge-renderer-utils": "static-1.3462",
  "onboarding-tours": "static-1.17372",
  "whisper-core-api": "static-1.7603",
  "fsm": "static-1.4215",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15784",
  "simple-menus-lib": "static-1.17301",
  "settings-ui-lib": "static-1.12986",
  "persist-promise": "static-1.4160",
  "crm-record-cards-service-types": "static-1.3865",
  "framework-data-schema-resolvers": "static-1.7350",
  "location-customization-utils-lib": "static-1.10384",
  "getting-started-shared-tasks": "static-1.19531",
  "growth-data-modal": "static-1.6109",
  "growth-onboarding-next-action-utils": "static-1.2952",
  "navigation-components": "static-1.19127",
  "onboarding-tours-client": "static-1.5587",
  "onboarding-tours-utils": "static-1.1439",
  "ui-shepherd-tracker": "static-1.8114",
  "user-context": "static-1.5511",
  "react-flip-move": "static-1.82",
  "framework-data-schema-quick-fetch": "static-1.7255",
  "onboarding-data-sync-lib": "static-1.2813",
  "growth-onboarding-next-action-components": "static-1.2980",
  "user-context-client": "static-1.4966",
  "nest": "static-1.689",
  "getting-started-shared-tasks-store": "static-1.18649",
  "InboxConnectUtils": "static-4.15812",
  "meetings-connect-utils-lib": "static-1.8074",
  "onboarding-scopes": "static-1.6910"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30989",
  "emoji-mart": "/emoji-mart/static-3.6",
  "feedback-schema": "/feedback-schema/static-1.55569",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8494",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11947",
  "I18n": "/I18n/static-7.1705",
  "quartz": "/quartz/static-1.7636",
  "quartz-config": "/quartz-config/static-1.1414",
  "quartz-core": "/quartz-core/static-1.6855",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reselect": "/reselect/static-3.16",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1081",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55556",
  "feedback-utils": "/feedback-utils/static-1.55560",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4919",
  "forms-utils-lib": "/forms-utils-lib/static-1.13308",
  "foundations-assets": "/foundations-assets/static-1.5343",
  "foundations-components": "/foundations-components/static-1.8718",
  "foundations-theming": "/foundations-theming/static-1.4944",
  "hub-http": "/hub-http/static-1.6665",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12254",
  "icons": "/icons/static-2.700",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4223",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17193",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5648",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.517",
  "tinymce-plugins": "/tinymce-plugins/static-1.58477",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1274",
  "UIComponents": "/UIComponents/static-3.8893",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3913",
  "quartz-webpack": "/quartz-webpack/static-1.3860",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2660",
  "property-description-translator": "/property-description-translator/static-1.4276",
  "HeadJS": "/HeadJS/static-2.818",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3605",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.26",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4765",
  "jasmine-runner": "/jasmine-runner/static-1.6909",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-unrevert-default-instrumentation.4",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.904",
  "hubspotter-http": "/hubspotter-http/static-1.4968",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.602",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-unrevert-default-instrumentation.4",
  "quartz-auth": "/quartz-auth/static-1.1311",
  "quartz-head": "/quartz-head/static-1.1301",
  "quartz-i18n": "/quartz-i18n/static-1.1311",
  "quartz-routing": "/quartz-routing/static-1.1066",
  "quartz-test": "/quartz-test/static-1.1311",
  "quartz-tracking": "/quartz-tracking/static-1.1015",
  "trellis-components": "/trellis-components/static-1.3062",
  "ui-fonts": "/ui-fonts/static-1.1209",
  "usage-tracker-container": "/usage-tracker-container/static-1.7769",
  "usage-tracker-core": "/usage-tracker-core/static-1.7629",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.346",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7605",
  "reference-resolvers": "/reference-resolvers/static-1.8637",
  "sanitize-text": "/sanitize-text/static-1.8615",
  "PatternValidationJS": "/PatternValidationJS/static-1.3343",
  "ReduxMessenger": "/ReduxMessenger/static-2.10827",
  "outpost": "/outpost/static-1.4589",
  "rpc-client-utils": "/rpc-client-utils/static-1.5128",
  "sanitize": "/sanitize/static-1.4931",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4987",
  "floating-ui": "/floating-ui/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9880",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.100",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.3043",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3427",
  "foundations-theming-base": "/foundations-theming-base/static-1.3929",
  "stylex": "/stylex/static-1.46",
  "hs-locale-management": "/hs-locale-management/static-1.392",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.157",
  "web-vitals": "/web-vitals/static-1.19",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9987",
  "atom": "/atom/static-1.5532",
  "codemirror": "/codemirror/static-5.106",
  "content-assistance-lib": "/content-assistance-lib/static-1.8397",
  "ContentUtils": "/ContentUtils/static-1.69435",
  "data-token-picker": "/data-token-picker/static-1.17105",
  "file-manager-components": "/file-manager-components/static-1.24806",
  "FileManagerCore": "/FileManagerCore/static-1.40305",
  "FileManagerLib": "/FileManagerLib/static-1.40446",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8377",
  "hub-http-contrib": "/hub-http-contrib/static-1.3488",
  "interframe": "/interframe/static-3.5198",
  "layout-dnd-components": "/layout-dnd-components/static-1.13196",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12171",
  "property-translator": "/property-translator/static-1.5836",
  "react-codemirror": "/react-codemirror/static-1.11098",
  "react-colorpicker": "/react-colorpicker/static-2.10667",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8564",
  "rich-text-lib": "/rich-text-lib/static-1.20523",
  "tinymce-data": "/tinymce-data/static-1.41448",
  "tinymce-themes": "/tinymce-themes/static-1.57333",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10322",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5660",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16909",
  "bender-build-tools": "/bender-build-tools/static-1.3556",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10871",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10869",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5465",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1453",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.538",
  "chirp-fetch": "/chirp-fetch/static-1.2361",
  "stylex-utils": "/stylex-utils/static-1.171",
  "chatspot-core": "/chatspot-core/static-1.23753",
  "copilot-toolkit": "/copilot-toolkit/static-1.12112",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13487",
  "data-fetching-client": "/data-fetching-client/static-1.10096",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5214",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9082",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29564",
  "usage-tracker": "/usage-tracker/static-1.7779",
  "cms-field-types": "/cms-field-types/static-1.5268",
  "content-icons-ui": "/content-icons-ui/static-1.2440",
  "integrations-lib": "/integrations-lib/static-1.17390",
  "customer-data-objects": "/customer-data-objects/static-1.8154",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2100",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5043",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "graphql": "/graphql/static-1.93",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4600",
  "poll-commands": "/poll-commands/static-1.3934",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9532",
  "video-components-external": "/video-components-external/static-1.12400",
  "video-data-lib": "/video-data-lib/static-1.36058",
  "audio-components": "/audio-components/static-1.6543",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.867",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30029",
  "FileManagerImages": "/FileManagerImages/static-1.37957",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1743",
  "html-to-image": "/html-to-image/static-1.65",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "salesImages": "/salesImages/static-1.714",
  "ui-universal-auth": "/ui-universal-auth/static-1.9691",
  "urlinator": "/urlinator/static-1.4972",
  "video-components": "/video-components/static-1.14402",
  "video-embed": "/video-embed/static-1.36892",
  "ts-schema": "/ts-schema/static-1.4387",
  "ContentData": "/ContentData/static-1.69510",
  "layout-data-lib": "/layout-data-lib/static-1.10496",
  "react-dnd-compat": "/react-dnd-compat/static-1.5068",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2003",
  "external-options-client-types": "/external-options-client-types/static-1.4433",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6048",
  "hs-resources": "/hs-resources/static-1.651",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4144",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9360",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3518",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11604",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5895",
  "magpie-types": "/magpie-types/static-1.5355",
  "simple-logging-lib": "/simple-logging-lib/static-1.3508",
  "avatar-components": "/avatar-components/static-1.2944",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10291",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7039",
  "flux-actions": "/flux-actions/static-1.380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5336",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14805",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6074",
  "laboratory-lib": "/laboratory-lib/static-3.7606",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8220",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10733",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1078",
  "breeze-engine-core": "/breeze-engine-core/static-1.1378",
  "highlight.js": "/highlight.js/static-1.90",
  "pulse": "/pulse/static-1.1102",
  "navigation-messaging": "/navigation-messaging/static-1.8454",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13560",
  "content-media-compositions": "/content-media-compositions/static-2.17567",
  "idb-keyval": "/idb-keyval/static-1.55",
  "media-bridge-lib": "/media-bridge-lib/static-1.19614",
  "nudge-client-utils": "/nudge-client-utils/static-1.3386",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1487",
  "social-insights-client-types": "/social-insights-client-types/static-1.22898",
  "advanced-menus-core": "/advanced-menus-core/static-1.15785",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12546",
  "ExportDialog": "/ExportDialog/static-6.10828",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35145",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4105",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4436",
  "event-emitter": "/event-emitter/static-1.1419",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.469",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4327",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3768",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4000",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6201",
  "reactive-lib": "/reactive-lib/static-1.1179",
  "trellis-migration-context": "/trellis-migration-context/static-1.35",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.795",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3465",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.605",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "nav-meta": "/nav-meta/static-1.30764",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3143",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3462",
  "onboarding-tours": "/onboarding-tours/static-1.17372",
  "whisper-core-api": "/whisper-core-api/static-1.7603",
  "fsm": "/fsm/static-1.4215",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15784",
  "simple-menus-lib": "/simple-menus-lib/static-1.17301",
  "settings-ui-lib": "/settings-ui-lib/static-1.12986",
  "persist-promise": "/persist-promise/static-1.4160",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3865",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7350",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10384",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19531",
  "growth-data-modal": "/growth-data-modal/static-1.6109",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2952",
  "navigation-components": "/navigation-components/static-1.19127",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5587",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1439",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8114",
  "user-context": "/user-context/static-1.5511",
  "react-flip-move": "/react-flip-move/static-1.82",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7255",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2813",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2980",
  "user-context-client": "/user-context-client/static-1.4966",
  "nest": "/nest/static-1.689",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18649",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15812",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8074",
  "onboarding-scopes": "/onboarding-scopes/static-1.6910"
}
};
